module.exports = __webpack_public_path__ + "img/who_we_are.936a1724.svg";